module.exports = __webpack_public_path__ + "media/images/slide-image-2d86ec33a6a1511340299925f3ec4a8e.jpg";